import { Vue, Options, prop } from 'vue-class-component';

import './launch-button.scss';

const CN = 'launch-button';

class Props {
  href: string;
  label = prop({ default: '' });
  size = prop<'md' | 'sm'>({ default: 'md' });
}

@Options({
  name: 'launch-button',
})
export default class LaunchButton extends Vue.with(Props) {
  declare $refs: {
    link: HTMLAnchorElement;
  };

  render() {
    const { href, label, size } = this;
    return (
      <div class={CN}>
        <r-button
          class={`${CN}__btn`}
          color="primary"
          data-testid="launch-button"
          icon="launch"
          onclick={this.open}
          size={size}
        >
          {label}
        </r-button>
        <a ref="link" class={`${CN}__link`} href={href} rel="noreferrer" target="_blank" />
      </div>
    );
  }

  private open() {
    this.$refs.link.click();
  }
}
